module.exports = __webpack_public_path__ + "media/images/wfc/city-4-a3dadc2cf3b2e5581c04953b71f6f581.jpg";